import styled from 'styled-components';
import {ReactNode} from "react";
import { CloseRounded } from '@mui/icons-material';

interface ModalProps {
    close: () => void;
    title: string;
    children?: ReactNode;
}

const ModalStyle = styled.div`
  position: fixed;
  color: black;
  z-index: 1000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 500px;
  border-radius: 12px;
  max-height: 600px;
  overflow-y: auto;
  background: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  font-weight: 800;
  font-size: 1.3rem;
  border-bottom: 1px solid #e6e6e6;
`;

const ModalClose = styled.div`
  position: absolute;
  right: 7.5px;
  top: 7.5px;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  background: #f0f0f0;
  transition: .1s;
  &:hover {
    background: #e7e7e7;
  }
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3rem;
  color: #646464;
`;

const ModalBody = styled.div`
  display: grid;
  gap: .5rem;
  padding: .5rem;
`;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.8);
  z-index: 999;
`;

export default function Modal(props: ModalProps) {
    return <>
        <Backdrop onClick={props.close} />
        <ModalStyle>
            <ModalHeader>
                {props.title}
            </ModalHeader>
            <ModalClose onClick={props.close}>
              <CloseRounded />
            </ModalClose>
            <ModalBody>
                {props.children}
            </ModalBody>
        </ModalStyle>
    </>
}